// import { configureStore } from "@reduxjs/toolkit";
// import logger from "redux-logger";
// import rootReducer from "../reducers/index";
import { composeWithDevTools } from "@redux-devtools/extension";
import { applyMiddleware, combineReducers, createStore } from "redux";
import thunk from "redux-thunk";
import {
  addPasswordReducer,
  otpVerifyReducer,
  resendClientCredentialsReducer,
  updateForgottenPasswordReducer,
  userForgotPasswordReducer,
  userLoginReducer,
  userRegisterReducer,
} from "../reducers/Auth";
import {
  addNewClientReducer,
  addScanCodeReducer,
  agentUpdateProfileReducer,
  checkMrnReducer,
  checkPatientEmailReducer,
  checkPatientPhoneReducer,
  createWorkspaceReducer,
  deleteAgentReducer,
  deleteClientReducer,
  generateApiKeyReducer,
  getAgencyEmailReducer,
  getAgencyReducer,
  getAgentProfileReducer,
  getAgentsListReducer,
  getAllAgenciesReducer,
  getAllClientsReducer,
  getAllClientsUnpaginatedReducer,
  getClientDataReducer,
  getQrCodeReducer,
  getUnpaginatedAgentsListReducer,
  inviteAgentReducer,
  reshareAgencyCredsReducer,
  updateAgencyReducer,
  updateAgentTeamMembersReducer,
  updateClientReducer,
  updateNotificationSendTimeReducer,
} from "../reducers/Agency";
import Cookies from "js-cookie";
import {
  addEducationSetupReducer,
  addEquipSetupReducer,
  addNewCaseReducer,
  addPatientDetailsReducer,
  addPatientPasswordReducer,
  addRecordConsentReducer,
  deleteCaseReducer,
  generateEvidenceReducer,
  getAllCasesReducer,
  getAllPatientsByAgencyReducer,
  getPatientByPatientIdReducer,
  getPatientAgentRolesReducer,
  getChartPainlogsReducer,
  getClientPainlogsReducer,
  getDashboardAlertsReducer,
  getDashboardAnalyticsReducer,
  getMedicineDataReducer,
  getNextPatientReducer,
  getPatientReportsReducer,
  getPieChartStatsReducer,
  getTabsCountReducer,
  getUnpaginatedPatientsReducer,
  getUnreadChatMessagesReducer,
  patientListingStateReducer,
  reEnrollPatientReducer,
  unEnrollPatientReducer,
  updateCaseReducer,
  getPinnedNotesReducer,
  getMinimisedNoteReducer,
  deletePatientNoteReducer,
  getPainStatsReducer,
  getLastLabDateReducer,
  createEnrolmentReducer,
  getEnrolmentsListReducer,
  logEnrolmentVisitReducer,
  pcmEnrolmentConsentReducer,
  getPatientOverviewSummaryReducer,
  unEnrolmentProgramReducer,
  updateContactNumberReducer,
  getEnrolmentTimelineReducer,
  updateMobilePasswordReducer,
  getQolAnswersReducer,
  getBmiResponsesReducer,
  getPhqResponsesReducer,
  getOncologyResponsesReducer,
} from "../reducers/Patients";
import {
  addBulkNotesReducer,
  changedAgencyIdReducer,
  createCustomNotesReducer,
  disableAppAccessReducer,
  enableAppAccessReducer,
  getAlertNotificationsReducer,
  getAllNotificationsReducer,
  getBodyPartsReducer,
  getChatNotificationsReducer,
  getCurrentPatientIndexReducer,
  getMobileStatusReducer,
  getReviewedPatientsReducer,
  getUnreviewedPatientsReducer,
  getUserActivityNotificationsReducer,
  getUserFeedNotificationsReducer,
  isActionPerformedReducer,
  markAsReadNotificationsReducer,
  markPatientReviewedReducer,
  sendBulkMessagesReducer,
  sendInactiveEmailReminderReducer,
  sendPainLogReminderReducer,
  sendPendingEmailReminderReducer,
  setShowReviewedScreenReducer,
  timerReducer,
  trackingImportPatientsReducer,
  updateCustomNotesReducer,
} from "../reducers/AppConfig";
import {
  cancelBillingSubscriptionReducer,
  createBillingSubscriptionReducer,
  getBillingSubscriptionReducer,
  updateBillingSubscriptionReducer,
} from "../reducers/BillingSubscription";
import {
  getMedicinesReducer,
  getStepsCountReducer,
} from "../reducers/StepsCount";
import {
  createBulkTimeReducer,
  createTimeEntryReducer,
  deleteTimeEntryReducer,
  getNotesReducer,
  getTimeEntryReducer,
  updateTimeEntryReducer,
} from "../reducers/TimeEntry";
import {
  addDiagnosisCodeReducer,
  getDiagnosisOptionsReducer,
  removeDiagnosisCodeReducer,
} from "../reducers/DiagnosisReducers";
import {
  createOrganizationReducer,
  getBillBreakDownReducer,
  getBillInvoicesReducer,
  getCurrentBillReducer,
  getOrgAgentsReducer,
  getOrganizationReducer,
  getOrgPatientsCountReducer,
  getOrgPaymentDetailsReducer,
  getOrgSubscriptionReducer,
  getPaymentInvoiceReducer,
  updateOrganizationReducer,
} from "../reducers/OrganizationReducers";
import {
  addCptDiagnosticCodesReducer,
  exportReportReducer,
  getCptCodeDetailReducer,
  getCptCodesReducer,
  initCptSetupReducer,
  removeCptDiagnosisCodeReducer,
  updateCptCodeReducer,
} from "../reducers/CptCodesReducers";
import {
  assignBulkPatientsReducer,
  checkImportStatusReducer,
  exportBulkEvidenceReducer,
  getAllImportStatsReducer,
  getExportStatsReducer,
  getImportHistoryPatientsReducer,
  getImportHistoryReducer,
  getImportPatientsListReducer,
  getStatsByImportIdReducer,
  importPatientFileReducer,
  setImportIdReducer,
} from "../reducers/ImportFileReducers";
import {
  downloadAllReportReducer,
  getAllPayersReducer,
  getCptCodesSummaryReducer,
  getCptTabsCountReducer,
  getReportCptCodesListReducer,
  getReportsListReducer,
  getReportStatsReducer,
  retryEocReportReducer,
} from "../reducers/Reports";
import {
  getAdlActivitiesReducer,
  getAllAppointments,
  getToAppointmentsReducer,
  getUnreviewedLabReportsReducer,
  getUpcomingAppointmentsReducer,
  markedAllLabReportsReviewedReducer,
  markedLabReportReviewedReducer,
} from "../reducers/Appointments";
import {
  createCarePlanReducer,
  createGoalPlanReducer,
  createMedicationPlanReducer,
  createPlanAssessmentReducer,
  createPlanInterventionReducer,
  createPlanMemberReducer,
  createPlanProblemReducer,
  createPlanSocialContextReducer,
  editCarePlanReducer,
  editGoalPlanReducer,
  editMedicationPlanReducer,
  editPlanInterventionReducer,
  editPlanMemberReducer,
  editPlanProblemReducer,
  editPlanSocialContextReducer,
  getCarePlanReducer,
  getCarePlanSummaryReducer,
  getPlanAssessmentReducer,
  getPlanGoalsListReducer,
  getPlanInterventionsListReducer,
  getPlanMedicationsListReducer,
  getPlanMembersListReducer,
  getPlanProblemsListReducer,
  getPlanSocialContextReducer,
  getPlanVersionsListReducer,
  savePlanVersionReducer,
  updatePlanAssessmentReducer,
} from "../reducers/CarePlan";
import { create, get, update } from "lodash";
import {
  seedPatientsReducer,
  seedSubmitReducer,
  seedLogsReducer,
  seedRegistrationReducer,
  seedDeviceCyclesReducer,
  seedBillingEvalReducer,
} from "../pages/seeding_entry/reducer";

const reducer = combineReducers({
  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  userForgotPassword: userForgotPasswordReducer,
  otpVerify: otpVerifyReducer,
  createWorkspace: createWorkspaceReducer,
  createOrganization: createOrganizationReducer,
  getOrganization: getOrganizationReducer,
  updateOrganization: updateOrganizationReducer,
  getOrgPatientsCount: getOrgPatientsCountReducer,
  getOrgAgents: getOrgAgentsReducer,
  getCurrentMonthBill: getCurrentBillReducer,
  getBillBreakdown: getBillBreakDownReducer,
  getPaymentInvoice: getPaymentInvoiceReducer,
  getBillInvoices: getBillInvoicesReducer,
  getOrgPaymentDetails: getOrgPaymentDetailsReducer,
  changedAgencyId: changedAgencyIdReducer,
  updateForgotPassword: updateForgottenPasswordReducer,
  addPassword: addPasswordReducer,
  agentProfile: getAgentProfileReducer,
  getAgencyDetail: getAgencyReducer,
  updateAgency: updateAgencyReducer,
  getQrCodeImage: getQrCodeReducer,
  addScanCode: addScanCodeReducer,
  getAgencyEmail: getAgencyEmailReducer,
  addPatientDetails: addPatientDetailsReducer,
  addPatientPassword: addPatientPasswordReducer,
  reshareAgencyCreds: reshareAgencyCredsReducer,
  reEnrollPatient: reEnrollPatientReducer,
  getAllAgencies: getAllAgenciesReducer,
  agentUpdateProfile: agentUpdateProfileReducer,
  updateNotificationSendTime: updateNotificationSendTimeReducer,
  getAgentsList: getAgentsListReducer,
  getUnpaginatedAgentLists: getUnpaginatedAgentsListReducer,
  deleteAgent: deleteAgentReducer,
  trackImportPatients: trackingImportPatientsReducer,
  checkImportStatus: checkImportStatusReducer,
  importPatientFile: importPatientFileReducer,
  exportBulkEvidence: exportBulkEvidenceReducer,
  getImportPatients: getImportPatientsListReducer,
  inviteAgent: inviteAgentReducer,
  getUnreviewedPatients: getUnreviewedPatientsReducer,
  getReviewedPatients: getReviewedPatientsReducer,
  markPatientReviewed: markPatientReviewedReducer,
  patientListingState: patientListingStateReducer,
  getNextPatient: getNextPatientReducer,
  getImportId: setImportIdReducer,
  assignBulkMembers: assignBulkPatientsReducer,
  getCurrentPatientIndex: getCurrentPatientIndexReducer,
  isActionPerformedDone: isActionPerformedReducer,
  getShowReviewedScreen: setShowReviewedScreenReducer,
  updateAgentTeamMembers: updateAgentTeamMembersReducer,
  getAllClients: getAllClientsReducer,
  getAllClientsUnpaginated: getAllClientsUnpaginatedReducer,
  getClientData: getClientDataReducer,
  resendClientCredentials: resendClientCredentialsReducer,
  addNewClient: addNewClientReducer,
  updateClient: updateClientReducer,
  deleteClient: deleteClientReducer,
  getAllCases: getAllCasesReducer,
  getAllAgencyPatients: getAllPatientsByAgencyReducer,
  getAllUnpaginatedPatients: getUnpaginatedPatientsReducer,
  patientDetailByPatientId: getPatientByPatientIdReducer,
  patientAgentRoles: getPatientAgentRolesReducer,
  getPatientOverviewSummary: getPatientOverviewSummaryReducer,
  createEnrolment: createEnrolmentReducer,
  getEnrolmentsList: getEnrolmentsListReducer,
  logEnrolmentVisit: logEnrolmentVisitReducer,
  pcmEnrolmentConsent: pcmEnrolmentConsentReducer,
  addRecordConsent: addRecordConsentReducer,
  addEquipSetup: addEquipSetupReducer,
  addEducationSetup: addEducationSetupReducer,
  unEnrollPatient: unEnrollPatientReducer,
  getClientPainlogs: getClientPainlogsReducer,
  getLastLabDate: getLastLabDateReducer,
  getPainStats: getPainStatsReducer,
  getChartPainLogs: getChartPainlogsReducer,
  getMedicineData: getMedicineDataReducer,
  addNewCase: addNewCaseReducer,
  updateCase: updateCaseReducer,
  deletedCase: deleteCaseReducer,
  dashboardAnalytics: getDashboardAnalyticsReducer,
  dashboardAlerts: getDashboardAlertsReducer,
  getUnreadChatMessages: getUnreadChatMessagesReducer,
  disableAppAccess: disableAppAccessReducer,
  enableAppAccess: enableAppAccessReducer,
  getUserFeedNotifications: getUserFeedNotificationsReducer,
  getAllNotifications: getAllNotificationsReducer,
  getChatNotifications: getChatNotificationsReducer,
  getAlertNotifications: getAlertNotificationsReducer,
  getUserActivityNotifications: getUserActivityNotificationsReducer,
  markedAsReadNotifications: markAsReadNotificationsReducer,
  getAllBodyParts: getBodyPartsReducer,
  getPieChartStats: getPieChartStatsReducer,
  getBillingSubscription: getBillingSubscriptionReducer,
  createBillingSubscription: createBillingSubscriptionReducer,
  updateBillingSubscription: updateBillingSubscriptionReducer,
  cancelBillingSubscription: cancelBillingSubscriptionReducer,
  sendPainLogReminder: sendPainLogReminderReducer,
  addBulkNotes: addBulkNotesReducer,
  getStepsCount: getStepsCountReducer,
  getMedicinesStats: getMedicinesReducer,
  timerModal: timerReducer,
  createTimeEntry: createTimeEntryReducer,
  createBulkTime: createBulkTimeReducer,
  sendBulkMessages: sendBulkMessagesReducer,
  getTimeEntry: getTimeEntryReducer,
  deleteTimeEntry: deleteTimeEntryReducer,
  updateTimeEntry: updateTimeEntryReducer,
  getDiagnosisOptions: getDiagnosisOptionsReducer,
  addDiagnosisCode: addDiagnosisCodeReducer,
  removeDiagnosisCode: removeDiagnosisCodeReducer,
  getNotes: getNotesReducer,
  initCptSetup: initCptSetupReducer,
  getCptCodes: getCptCodesReducer,
  getCptCodeDetail: getCptCodeDetailReducer,
  updateCptCode: updateCptCodeReducer,
  removeCptDiagnosisCode: removeCptDiagnosisCodeReducer,
  addCptDiagnosticCodes: addCptDiagnosticCodesReducer,
  checkPatientEmail: checkPatientEmailReducer,
  checkPatientPhone: checkPatientPhoneReducer,
  checkMrn: checkMrnReducer,
  exportReport: exportReportReducer,
  getPatientReports: getPatientReportsReducer,
  createCustomNotes: createCustomNotesReducer,
  updateCustomNotes: updateCustomNotesReducer,
  getMobileStatus: getMobileStatusReducer,
  sendInactiveEmailReminder: sendInactiveEmailReminderReducer,
  sendPendingEmailReminder: sendPendingEmailReminderReducer,
  generateEvidenceReport: generateEvidenceReducer,
  getTabsCount: getTabsCountReducer,
  getReportsList: getReportsListReducer,
  downloadAllReport: downloadAllReportReducer,
  getReportStats: getReportStatsReducer,
  getReportCptCodesList: getReportCptCodesListReducer,
  getPinnedNotes: getPinnedNotesReducer,
  getMinimisedNote: getMinimisedNoteReducer,
  getAllPayers: getAllPayersReducer,
  retryEocReport: retryEocReportReducer,
  getCptTabsCount: getCptTabsCountReducer,
  getCptCodeSummary: getCptCodesSummaryReducer,
  deletePatientNote: deletePatientNoteReducer,
  generateApiKey: generateApiKeyReducer,
  getAdlActivities: getAdlActivitiesReducer,
  getAllAppointments: getAllAppointments,
  getToAppointments: getToAppointmentsReducer,
  getUpcomingAppointments: getUpcomingAppointmentsReducer,
  getUnreviewedLabReports: getUnreviewedLabReportsReducer,
  markedLabReportReviewed: markedLabReportReviewedReducer,
  markedAllLabReportsReviewed: markedAllLabReportsReviewedReducer,
  createCarePlan: createCarePlanReducer,
  getCarePlan: getCarePlanReducer,
  getCarePlanSummary: getCarePlanSummaryReducer,
  getPlanVersionsList: getPlanVersionsListReducer,
  createPlanAssessment: createPlanAssessmentReducer,
  getPlanAssessment: getPlanAssessmentReducer,
  updatePlanAssessment: updatePlanAssessmentReducer,
  createPlanProblem: createPlanProblemReducer,
  getPlanProblemsList: getPlanProblemsListReducer,
  editPlanProblem: editPlanProblemReducer,
  createGoalPlan: createGoalPlanReducer,
  getPlanGoalsList: getPlanGoalsListReducer,
  editGoalPlan: editGoalPlanReducer,
  createPlanIntervention: createPlanInterventionReducer,
  getPlanInterventionsList: getPlanInterventionsListReducer,
  editPlanIntervention: editPlanInterventionReducer,
  createMedicationPlan: createMedicationPlanReducer,
  getPlanMedicationsList: getPlanMedicationsListReducer,
  editMedicationPlan: editMedicationPlanReducer,
  createPlanMember: createPlanMemberReducer,
  getPlanMembersList: getPlanMembersListReducer,
  editPlanMember: editPlanMemberReducer,
  createPlanSocialContext: createPlanSocialContextReducer,
  getPlanSocialContext: getPlanSocialContextReducer,
  editPlanSocialContext: editPlanSocialContextReducer,
  savePlanVersion: savePlanVersionReducer,
  unenrolmentProgram: unEnrolmentProgramReducer,
  updateContactNumber: updateContactNumberReducer,
  editCarePlan: editCarePlanReducer,
  getEnrolmentTimeline: getEnrolmentTimelineReducer,
  updateMobilePassword: updateMobilePasswordReducer,
  getQolAnswers: getQolAnswersReducer,
  getBmiResponses: getBmiResponsesReducer,
  getPhqResponses: getPhqResponsesReducer,
  getOncologyResponses: getOncologyResponsesReducer,
  getAllImportStats: getAllImportStatsReducer,
  getExportStats: getExportStatsReducer,
  getImportHistory: getImportHistoryReducer,
  getStatsByImportId: getStatsByImportIdReducer,
  getImportHistoryPatients: getImportHistoryPatientsReducer,
  getOrgSubscription: getOrgSubscriptionReducer,
  seedPatients: seedPatientsReducer,
  seedSubmit: seedSubmitReducer,
  seedLogs: seedLogsReducer,
  seedRegistration: seedRegistrationReducer,
  seedDeviceCycles: seedDeviceCyclesReducer,
  seedBillingEval: seedBillingEvalReducer,
});

const token = Cookies.get("token") ?? null;
const agentId = Cookies.get("agent_id_vita") ?? null;
const agencyId = Cookies.get("agency_id_vita") ?? null;
const orgId = Cookies.get("org_id_vita") ?? null;

const initialState = {
  userLogin: {
    userInfo: { token, agentId, agencyId, orgId },
  },
};

const middlewares = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middlewares))
);

export default store;
